module.exports = __webpack_public_path__ + "img/9788933830468.747afc25.jpg";